'use strict';

var Sugar = require('sugar-core'),
    isInteger = require('./internal/isInteger');

Sugar.Number.defineInstance({

  'isInteger': function(n) {
    return isInteger(n);
  }

});

module.exports = Sugar.Number.isInteger;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/isInteger.js
// module id = 688
// module chunks = 0